import { SvgIcon } from '@mui/material';

export const DailyNewLegendIcon = () => (
  <SvgIcon viewBox='0 0 10 10' sx={{ width: '10px', height: '10px' }}>
    <rect width='10' height='10' rx='2' fill='#003F83' />
  </SvgIcon>
);
